import { type InputHTMLAttributes, type JSX, type MouseEvent } from "react";

export interface DealDateInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {}

/** Native date input that opens its calendar when any part of the field is clicked. */
export function DealDateInput({ disabled, onClick, ...props }: DealDateInputProps): JSX.Element {
  const handleClick = (event: MouseEvent<HTMLInputElement>): void => {
    onClick?.(event);

    if (disabled || event.defaultPrevented) {
      return;
    }

    try {
      event.currentTarget.showPicker?.();
    } catch {
      // Some Outlook webviews expose showPicker but reject it. Keep the native fallback usable.
    }
  };

  return <input {...props} type="date" disabled={disabled} onClick={handleClick} />;
}
